/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import React from 'react';
import { Input as SemanticInput, Form } from 'semantic-ui-react';
import _ from '../../translations';
import get from 'lodash/get';

const styles = {
    requiredText: {
        position: 'absolute',
        right: 5,
        bottom: 5,
        color: 'red',
        fontSize: '10px',
    },
};

class Input extends React.Component {
    onKeyPressed = e => {
        if (e.keyCode === 13) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    render() {
        const { minLength = false, label, islabelContained, pattern, toLowerCase = false, trim = false, labelPosition = null } = this.props;
        let { value = '' } = this.props;

        let className = '';
        let lengthTooShort = false;

        if (toLowerCase) {
            value = value.toLowerCase();
        }

        if (trim) {
            value = value.trim();
        }

        if (pattern) {
            const regex = new RegExp(pattern);
            if (value && value.length > 0 && !regex.test(value)) {
                value = value.substring(0, value.length - 1);
            }
        }

        if (value && value.length !== undefined && minLength && value.length < minLength) {
            className = 'length-too-short';
            lengthTooShort = true;
        }

        className = className + ' ' + get(this.props,'className','');

        return (
            <Form.Field style={{ position: 'relative' }}>
                <If condition={label && !islabelContained}>
                    <label>{label}</label>
                </If>
                <If condition={lengthTooShort}>
                    <span style={styles.requiredText}>{_(`Length must be at least %d characters`, minLength)}</span>
                </If>
                <SemanticInput
                    {...this.props}
                    value={value}                   
                    className={className}
                    label={(islabelContained) ? label : false}
                    labelPosition={labelPosition}
                    onKeyDown={this.onKeyPressed}
                />
            </Form.Field>
        );
    }
}

export default Input;
